export const openings = {
    urls: {
        student: 'https://phh.tbe.taleo.net/phh01/ats/careers/v2/jobSearch?org=GRANTTHORNTON&cws=57',
        experienced: 'https://phh.tbe.taleo.net/phh01/ats/careers/v2/jobSearch?org=GRANTTHORNTON&cws=56'
    },
    labels: {
        student: 'Campus Openings',
        experienced: 'Experienced Hire Openings'
    },
}